import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Button, Form, Input } from 'antd';
import { TempleBreadrumbs } from '../../../config/BreadcrumbConfig';
import useStore from '../../../store';
import PageHeader from '../../../component/PageHeader';
import ListComponent from './components/ListComponent';
import EditComponent from './components/EditComponent';
import AddComponent from './components/AddComponent';
import DeleteComponent from './components/DeleteComponent';
import BulkImport from './components/BulkImport';
import TempleImageApproveModal from './components/ImageApprover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import TempleSampleFile from '../../../assets/Temple-Template.xlsx';

const Temples = observer(() => {
	const [templeAddModal, setTempleAddModal] = useState(false);
	const [templeEditModal, setTempleEditModal] = useState(false);
	const [templeDeleteModal, setTempleDeleteModal] = useState(false);
	const [templeImport, setTempleImport] = useState(false);
	const [templeViewModal, setTempleViewModal] = useState(false);
	const [templeImageModal, setTempleImageModal] = useState(false);
	const { TEMPLE, AUTH } = useStore();

	const AddUserModal = () => {
		setTempleAddModal(true);
		AUTH.getAllByLookupKeyList(`lookupKey=popularity&isAdmin=false`);
	};

	const closeAddModal = () => {
		setTempleAddModal(false);
	};

	const openEdit = () => {
		AUTH.getAllByLookupKeyList(`lookupKey=popularity&isAdmin=false`);
		setTempleEditModal(true);
	};

	const closeEditModal = () => {
		setTempleViewModal(false);
		setTempleEditModal(false);
	};

	const openDelete = (data) => {
		setTempleDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setTempleDeleteModal(false);
	};

	const openView = () => {
		openEdit();
		setTempleViewModal(true);
	};

	const openImage = (id) => {
		setTempleImageModal(id);
	};

	const closeImageModal = () => {
		setTempleImageModal(false);
	};

	const addBulkImport = () => {
		setTempleImport(true);
	};
	const closeTempleImport = () => {
		setTempleImport(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			TEMPLE.searchValue = text;
			TEMPLE.setupGrid(TEMPLE.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			TEMPLE.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={TempleBreadrumbs.title}
				extra={[
					<Form.Item help={'Enter 3 character to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<a
						key={2}
						href={TempleSampleFile}
						target="_blank"
						download={'Temple-Template.xlsx'}
					>
						<Button type="primary" title={'Download Sample File'}>
							<FontAwesomeIcon icon={faDownload} />
						</Button>
					</a>,
					<Button key={3} type="primary" onClick={addBulkImport}>
						Bulk Temple Import
					</Button>,
					<Button
						key={4}
						type="primary"
						className="addBtn"
						onClick={AddUserModal}
					>
						Add Temple
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
				openViewModal={openView}
				openImageModal={openImage}
			/>
			<AddComponent visible={templeAddModal} onClose={closeAddModal} />
			<EditComponent
				visible={templeEditModal}
				viewMode={templeViewModal}
				onClose={closeEditModal}
			/>
			<DeleteComponent
				visible={templeDeleteModal}
				onClose={closeDeleteModal}
			/>
			<BulkImport visible={templeImport} onClose={closeTempleImport} />
			<TempleImageApproveModal
				visible={templeImageModal}
				onClose={closeImageModal}
			/>
		</div>
	);
});

export default Temples;
